// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import CheckboxListWithLabel from '../../../shared/components/checkbox-list-with-label';
import {FormattedMessage} from 'react-intl';
import {addCollectionLabels} from '../../../shared/services/add-collection-labels';
import {create as createHashMap} from '../../../shared/services/hashmap';
import {getSelectAllText} from '../../../reports/shared/services/criteria';

const RgaBODealerCriteria = props => {

    const dataTypeSelectionMessage = getSelectAllText(props.selectedDealers);

    return (
        <section className='rga-bo-report-dealer-criteria'>
            <CheckboxListWithLabel
                className='rga-bo-report-dealers'
                initialState={createHashMap(props.selectedDealers, 'value')}
                isRequired={true}
                label='Data Type'
                list={addCollectionLabels(props.selectedAccounts, 'value')}
                onChange={props.onDealerSelect}
                uid='value'
            />
            <button
                className='toggle-all'
                onClick={props.onSelectAllDealers}
                type='button'
            >
                <FormattedMessage id={dataTypeSelectionMessage}/>
            </button>
        </section>
    );

};

RgaBODealerCriteria.displayName = 'RgaBODealerCriteria';
RgaBODealerCriteria.propTypes = {
    onDealerSelect: PropTypes.func.isRequired,
    onSelectAllDealers: PropTypes.func.isRequired,
    selectedAccounts: PropTypes.arrayOf(PropTypes.object).isRequired,
    selectedDealers: PropTypes.arrayOf(PropTypes.object).isRequired
};

export default RgaBODealerCriteria;




// WEBPACK FOOTER //
// ./src/rga/reports/components/rga-bo-data-type-criteria.js